import React from "react";
import Header from "../components/header/Header";
import { Colors } from "../components/Colors";
import { FaInfo, FaInfoCircle, FaRegArrowAltCircleRight } from "react-icons/fa";
import Marquee from "react-fast-marquee";
import bears from "../assets/images";
import TreeDisplay from "../components/TreeDisplay";
import { Footer } from "../components/Footer";
import { ArrowCircleRight2, ArrowRight, ArrowRight2, ArrowRight3, BuyCrypto, InfoCircle } from "iconsax-react";

type HomeT = {
  onPress: () => void;
};

export default function Home({ onPress }: HomeT) {
  return (
    <>
      <Header />
      <main className="flex flex-col mx-auto justify-center space-y-20 items-center">
        <div className="flex flex-col items-center mt-10 text-center space-y-8">
          <div className="space-y-3">
            <h1
              className=" text-center md:leading-[3rem] text-[28px] md:text-[38px]"
              style={{ fontFamily: "greenStalk", color: Colors.modernBlack08 }}
            >
              It’s The{" "}
              <span style={{ color: Colors.primary }}>Angry Bears</span> <br />
              Hunt Season!
            </h1>
            <p className=" font-inter px-3 md:w-[80%] mx-auto text-zinc-400 text-center"></p>
          </div>
          <div className="flex flex-row space-x-3 w-[94%] items-center justify-center">
            <a
              // onClick={onPress}
              href="https://opensea.io/collection/angry-bera-2?tab=items"
              target="_blank"
              className="border-solid border-2 border-gray-200 rounded-[14px] h-[60px] w-[50%] lg:w-[30%] flex gap-2 items-center justify-center font-semibold text-ash bg-white"
            >
              <BuyCrypto variant="TwoTone" size={22} /> Opensea
            </a>
            <a
              href="http://discord.gg/STyfPhAGWa"
              target="_blank"
              className=" shadow-xl shadow-primary/50 rounded-[14px] h-[60px] w-[50%] lg:w-[30%] flex gap-2 items-center justify-center font-semibold text-white bg-primary"
            >
              Join Our Discord
              <ArrowCircleRight2 variant="TwoTone" size={22} />
            </a>
          </div>

          <div className="md:w-[calc(130px*6)] w-full z-0">
            <Marquee>
              <img
                src={bears.bear1}
                alt=""
                className="h-[130px] w-[130px] mr-4 rounded-xl"
              />
              <img
                src={bears.bear2}
                alt=""
                className="h-[130px] w-[130px] mr-4 rounded-xl"
              />
              <img
                src={bears.bear3}
                alt=""
                className="h-[130px] w-[130px] mr-4 rounded-xl"
              />
              <img
                src={bears.bear4}
                alt=""
                className="h-[130px] w-[130px] mr-4 rounded-xl"
              />
              <img
                src={bears.bear5}
                alt=""
                className="h-[130px] w-[130px] mr-4 rounded-xl"
              />
              <img
                src={bears.bear6}
                alt=""
                className="h-[130px] w-[130px] mr-4 rounded-xl"
              />
            </Marquee>
          </div>
        </div>

        <div className="flex flex-col items-center mt-10 text-center space-y-5">
          <p
            style={{ fontFamily: "greenStalk" }}
            className=" text-zinc-600 text-[28px] md:text-[38px]"
          >
            Project Roadmap
          </p>

          <p className=" font-inter px-3 md:w-[80%] text-zinc-400">
            AngryBearsNFT, A collection of 1670 angry bears onchain. The Angry
            Bears are marching into berachain, and they're not messing around!
            This fur-ocious collection of NFTs will leave you paws-itively
            claw-vering for more.
            <br className=" hidden md:block mt-5" /> Each bear is uniquely
            designed with its own bear-attitude and personal-bear-ity, making
            them the grizzliest and most un-bear-ably adorable addition to any
            NFT collection.
          </p>

          {/* tree component */}
          <div className=" md:w-[60%]">
            <TreeDisplay />
          </div>

          {/* <p className=" font-inter md:w-[80%] text-zinc-400">
            If you have completed the tasks above, Congratulations, you have
            made <br /> your way to the Angry Bears Whitelist, fill the form
            below to seal your application.
          </p>

          <a
            href="/"
            className="shadow-xl shadow-primary/50 rounded-[14px] h-[60px] w-[226px] flex gap-2 items-center justify-center font-semibold text-white bg-primary"
          >
            Seal Application <FaRegArrowAltCircleRight size={22} />
          </a> */}
        </div>
        <Footer />
      </main>
    </>
  );
}
